(() => {
  const name = 'trackUserData';

  TrackApp[name] = (() => () => {
    const xhrAnalytics = new XMLHttpRequest();
    xhrAnalytics.onreadystatechange = function trackUserDataOnReadyStateChange() {
      const { readyState, status, responseText } = xhrAnalytics;
      if (readyState === XMLHttpRequest.DONE && status === 200) {
        const data = JSON.parse(responseText);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'userData',
          customerNumber: data.analyticsUser.userId,
          customerHash: data.analyticsUser.hashedEmail,
        });
      }
    };
    xhrAnalytics.onerror = function trackUserDataOnError() {
      if (window.console) {
        // eslint-disable-next-line no-console
        console.warn('analytics error');
      }
    };
    xhrAnalytics.open('GET', '/analytics', true);
    xhrAnalytics.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
    xhrAnalytics.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhrAnalytics.send();
  })();
})();
